export default "__VITE_ASSET__fCT1PDbs__"